import useFwWingstopListLocationGroupLossPreventionKpis, {
  fwWingstopListLocationGroupLossPreventionKpisConfigs,
} from './useListLocationGroupLossPreventionKpis'
import useFwWingstopListLocationGuestKpis, {
  fwWingstopListLocationGuestKpisConfigs,
} from './useListLocationGuestKpis'
import useFwWingstopListLocationLossPreventionKpis, {
  fwWingstopListLocationLossPreventionKpisConfigs,
} from './useListLocationLossPreventionKpis'
import useFwWingstopListStorePerformanceKpis, {
  fwWingstopListStorePerformanceKpisConfigs,
} from './useListStorePerformanceKpis'
import useFwWingstopSystemwideOverview, {
  fwWingstopSystemwideOverviewConfigs,
} from './useListSystemwideOverview'

export const configs = {
  fwWingstopListLocationGroupLossPreventionKpis:
    fwWingstopListLocationGroupLossPreventionKpisConfigs,
  fwWingstopListLocationLossPreventionKpis:
    fwWingstopListLocationLossPreventionKpisConfigs,
  fwWingstopListLocationGuestKpis: fwWingstopListLocationGuestKpisConfigs,
  fwWingstopSystemwideOverview: fwWingstopSystemwideOverviewConfigs,
  fwWingstopListStorePerformanceKpis: fwWingstopListStorePerformanceKpisConfigs,
}

export const api = {
  fwWingstopListLocationGroupLossPreventionKpis:
    useFwWingstopListLocationGroupLossPreventionKpis,
  fwWingstopListLocationLossPreventionKpis:
    useFwWingstopListLocationLossPreventionKpis,
  fwWingstopListLocationGuestKpis: useFwWingstopListLocationGuestKpis,
  fwWingstopSystemwideOverview: useFwWingstopSystemwideOverview,
  fwWingstopListStorePerformanceKpis: useFwWingstopListStorePerformanceKpis,
}
